<template>
  <section class="section section-md bg-default pt-1">
    <div class="container">
      <h3>My Orders</h3>
      
      <div v-if="!loading">
        <!-- Table -->       
        <div v-if="rows.length" class="table-custom-responsive">
          <table class="table table-striped table-bordered align-middle">
            <thead class="table-light">
              <tr>
                <th>Order ID</th>
                <th>Product Name</th>                
                <th>Quantity</th>
                <th>Grand Total</th>
                <th>Order Date</th>
                <th>Payment Status</th>
                <th>Order Status</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              <template v-for="(order, oIndex) in rows" :key="oIndex">
                <tr
                  v-for="(item, iIndex) in order.order_details"
                  :key="`${oIndex}-${iIndex}`"
                >
                  <!-- Order ID only on first product row -->
                  <td v-if="iIndex === 0" :rowspan="order.order_details.length">
                    {{ order.order_id }}
                  </td>

                  <td>
                    <div class="d-flex align-items-center">
                      <img
                        v-if="item.product?.image_187x155"
                        :src="item.product.image_187x155"
                        alt="product"
                        width="60"
                        class="me-2 rounded"
                      />
                      <span>{{ item.product?.name }}</span>
                    </div>
                  </td>

                  <td>{{ item.quantity }}</td>
                  <td>${{ order.grand_total.toFixed(2) }}</td>

                  <td>{{ commonStore.formatDate(order.created_at) }}</td>

                  <!-- Payment and order status -->
                  <td v-if="iIndex === 0" :rowspan="order.order_details.length">
                    <span
                      class="badge text-uppercase"
                      :class="{
                        'bg-success': order.payment_status === 'COMPLETED',
                        'bg-danger': order.payment_status !== 'COMPLETED',
                      }"
                    >
                      {{ order.payment_status }}
                    </span>
                  </td>

                  <td v-if="iIndex === 0" :rowspan="order.order_details.length">
                    <span
                      class="badge text-uppercase"
                      :class="commonStore.getStatusClass(order?.order_process_status)"
                    >
                      {{ order?.order_process_status }}
                    </span>
                  </td>

                  <td>
                    <button class="btn btn-sm btn-primary" data-bs-toggle="modal"
    data-bs-target="#orderDetailsModal" @click="setCurrentOrder(order)">View Details</button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <!-- Pagination -->
        <nav v-if="pagination.last_page > 1" class="mt-4">
          <ul class="pagination justify-content-center mb-0">
            <!-- Prev -->
            <li
              class="page-item"
              :class="{ disabled: pagination.current_page === 1 }"
            >
              <button
                class="page-link"
                @click="changePage(pagination.current_page - 1)"
                :disabled="pagination.current_page === 1"
              >
                ‹ Prev
              </button>
            </li>

            <!-- Page Numbers -->
            <li
              v-for="page in pagination.last_page"
              :key="page"
              class="page-item"
              :class="{ active: page === pagination.current_page }"
            >
              <button class="page-link" @click="changePage(page)">
                {{ page }}
              </button>
            </li>

            <!-- Next -->
            <li
              class="page-item"
              :class="{ disabled: pagination.current_page === pagination.last_page }"
            >
              <button
                class="page-link"
                @click="changePage(pagination.current_page + 1)"
                :disabled="pagination.current_page === pagination.last_page"
              >
                Next ›
              </button>
            </li>
          </ul>
        </nav>

        <div v-else-if="!rows.length" class="text-center py-4 text-muted">
          No recent orders found.
        </div>
      </div>

      <div v-else class="text-center py-5">
        <div class="lds-dual-ring"></div>
        <h6 class="mt-3 text-muted">Loading orders...</h6>
      </div>

    </div>
  </section>
  <OrderDetailsModal :order="currentOrder" />
</template>

<script setup>
import { api } from '@/plugins/axios'
import { onMounted, ref } from 'vue'
import { useDashboardStore } from '@/stores/dashboardStore'
import { storeToRefs } from 'pinia'
import OrderDetailsModal from '@/components/common/OrderDetailsModal.vue'
import { useCommonStore } from '@/stores/commonStore'

const commonStore = useCommonStore()
const dashboardStore = useDashboardStore()
const { rows, pagination, loading } = storeToRefs(dashboardStore)
const currentOrder = ref({})

onMounted(() => {
  dashboardStore.getRecentOrders('all')
})

function changePage(page) {
  if (page >= 1 && page <= pagination.value.last_page) {
    dashboardStore.getRecentOrders('all', page)
  }
}

function setCurrentOrder(order) {
  currentOrder.value = order 
}
</script>

<style scoped>
.table img {
  object-fit: cover;
}

.pagination button {
  border: none;
  background: none;
}

.page-link {
  cursor: pointer;
}
</style>
